module.exports = __webpack_public_path__ + "static/desktop_background-240eeed8d4016b43a4e3db311a0d710e.jpg";